export { RecentlyClaimedCompanies } from './RecentlyClaimedCompanies';
